// src/components/AccountCreation/Step5_Status.js
import React from 'react';
import { CheckCircleIcon, XCircleIcon } from './Icons';

const Step5_Status = ({ status, reset }) => {
  return (
    <div className="text-center">
      {status === 'success' ? (<><CheckCircleIcon /><h2 className="fw-bold mt-3">Account Created Successfully!</h2><p className="text-muted">Welcome aboard! Your subscription is active.</p></>) : (<><XCircleIcon /><h2 className="fw-bold mt-3">Payment Failed</h2><p className="text-muted">There was an issue processing your payment. Please try again.</p></>)}
      <button onClick={reset} className="btn btn-primary mt-4">Start Over</button>
    </div>
  );
};

export default Step5_Status;
